<template>
  <v-flex>
    <div class="d-flex align-center">
      <h1>{{ name }}</h1>
    </div>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-card>
      <v-card-title>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="countries"
        :search="searchTrimmed"
        class="elevation-1"
        hide-actions
        v-if="!loading"
      >
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded && getDistributors(props.item.id)">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.code }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card flat>
            <v-card-text>
              <v-chip v-for="distributor in distributorsByCountry"
                      :key="distributor.id"
                      @click="$router.push(`/distributors/${distributor.id}`)">
                {{distributor.name}}
              </v-chip>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import { COUNTRIES_LIST } from '../../store/actions/countries'
import { DISTRIBS_BY_COUNTRY } from '../../store/actions/distributors'

export default {
  data: () => ({
    name: 'Countries',
    loading: true,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Code', value: 'code' }
    ],
    search: '',
    distributorsByCountry: []
  }),
  computed: {
    ...mapGetters([
      'countries'
    ]),
    searchTrimmed: function () {
      return this.search.trim()
    }
  },
  methods: {
    getDistributors: async function (id) {
      this.distributorsByCountry = await this.$store.dispatch(DISTRIBS_BY_COUNTRY, {countryId: id})
      console.log(this.distributorsByCountry)
    }
  },
  mounted: async function () {
    if (this.$route.params.search) {
      this.search = this.$route.params.search
    }
    this.loading = true
    await this.$store.dispatch(COUNTRIES_LIST)
    this.loading = false
  },
  watch: {
    '$route': async function (to) {
      if (to.params.search) {
        this.search = to.params.search
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Countries/Index.vue